(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kde-bucket-matchmaker"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const finder = root.querySelector('[data-kdm-finder]');
    const stage = root.querySelector('[data-kdm-stage]');
    const back = root.querySelector('[data-kdm-back]');
    const restart = root.querySelector('[data-kdm-restart]');
    const labels = JSON.parse(root.querySelector('[data-kdm-labels]').textContent);
    let history = [];
    let current = 'job';
    const template = key => root.querySelector(key.startsWith('@') ? '[data-kdm-result="' + key.slice(1) + '"]' : '[data-kdm-question="' + key + '"]');
    function updateUrl() {
      const url = new URL(window.location.href);
      if (current.startsWith('@')) url.searchParams.set('match', history.map(x => x.choice).join('.'));
      else url.searchParams.delete('match');
      try { window.history.replaceState(null, '', url); } catch (error) {}
    }
    function render(focus = true) {
      const source = template(current);
      if (!source) { current = 'job'; history = []; return render(focus); }
      stage.replaceChildren(source.content.cloneNode(true));
      const result = current.startsWith('@');
      const phase = result ? 3 : history.length ? 2 : 1;
      finder.querySelector('progress').value = phase;
      finder.querySelectorAll('.kdm-steps li').forEach((item, i) => {
        if (i + 1 === phase) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      back.hidden = !history.length;
      restart.hidden = !history.length;
      if (result) stage.querySelector('[data-kdm-answers]').textContent = labels.result_intro + ': ' + history.map(x => x.label).join(' → ');
      updateUrl();
      if (focus) stage.querySelector('h2').focus({preventScroll:true});
    }
    stage.addEventListener('click', async event => {
      const choice = event.target.closest('[data-kdm-choice]');
      if (choice) {
        history.push({question:current,choice:choice.dataset.kdmChoice,label:choice.querySelector('strong').textContent});
        current = choice.dataset.next;
        render();
      }
      const share = event.target.closest('[data-kdm-share]');
      if (share) {
        const status = stage.querySelector('[data-kdm-status]');
        try { await navigator.clipboard.writeText(window.location.href); status.textContent = labels.copied; }
        catch (error) { status.textContent = labels.copy_failed; }
      }
    });
    back.addEventListener('click', () => { const previous = history.pop(); if (previous) {current = previous.question; render();} });
    restart.addEventListener('click', () => {history = []; current = 'job'; render();});
    const saved = new URL(window.location.href).searchParams.get('match');
    if (saved && /^[a-z0-9_.-]{1,100}$/.test(saved)) {
      for (const id of saved.split('.')) {
        const source = template(current);
        const option = source && Array.from(source.content.querySelectorAll('[data-kdm-choice]')).find(button => button.dataset.kdmChoice === id);
        if (!option) {history = []; current = 'job'; break;}
        history.push({question:current,choice:id,label:option.querySelector('strong').textContent});
        current = option.dataset.next;
      }
      if (!current.startsWith('@')) {history = []; current = 'job';}
    }
    finder.hidden = false;
    render(false);
  }
  document.querySelectorAll('[data-kdm]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kdm]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kde-dealer-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kde-dealer-directory')) customElements.define('kde-dealer-directory', class extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;this.ready=true;this.rows=[];this.partners=[];this.page=1;this.position=null;
    this.q=s=>this.querySelector(s);this.norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    this.query=this.q('[data-query]');this.country=this.q('[data-country]');this.region=this.q('[data-region]');this.status=this.q('[data-status]');
    this.query.addEventListener('input',()=>{this.page=1;this.render()});
    this.country.addEventListener('change',()=>{this.regions();this.page=1;this.render()});
    this.region.addEventListener('change',()=>{this.page=1;this.render()});
    this.q('[data-radius]').addEventListener('change',()=>{this.page=1;this.render()});
    this.q('[data-clear]').addEventListener('click',()=>{this.locationRequest=(this.locationRequest||0)+1;this.q('[data-nearby-zip]').value='';this.q('[data-locate]').disabled=false;this.q('[data-locate]').textContent='Use my location';this.query.value='';this.country.value='';this.regions();this.position=null;this.q('[data-radius-wrap]').hidden=true;this.q('[data-location]').textContent='Allow location access when prompted, or enter a ZIP above to find nearby dealers.';this.page=1;this.render()});
    this.q('[data-prev]').addEventListener('click',()=>{this.page--;this.render();this.status.scrollIntoView({block:'center',behavior:'smooth'})});
    this.q('[data-next]').addEventListener('click',()=>{this.page++;this.render();this.status.scrollIntoView({block:'center',behavior:'smooth'})});
    this.q('[data-locate]').addEventListener('click',()=>this.locate());this.q('[data-zip-form]').addEventListener('submit',e=>{e.preventDefault();this.locateZip()});
    fetch(this.dataset.source).then(r=>{if(!r.ok)throw Error('load');return r.json()}).then(data=>{
      this.partners=data.partners.map(p=>({...p,logo:p.logo.startsWith('theme:')?new URL(p.logo.slice(6),new URL(this.dataset.source,location.href)).href:p.logo}));this.rows=data.dealers.map(r=>({...r,index:this.norm([r.name,r.address,r.region,r.country].join(' '))}));
      [...new Set(this.rows.map(r=>r.country))].sort().forEach(c=>this.country.add(new Option(c,c)));this.regions();this.render();
    }).catch(()=>{this.status.textContent='The directory could not load. Please refresh this page or contact K&D below for help finding a dealer.'});
  }
  regions(){this.region.replaceChildren(new Option('All states / provinces',''));[...new Set(this.rows.filter(r=>!this.country.value||r.country===this.country.value).map(r=>r.region).filter(Boolean))].sort().forEach(s=>this.region.add(new Option(s,s)))}
  setPosition(lat,lng,label){this.position=[lat,lng];this.query.value='';this.country.value='';this.regions();this.page=1;this.q('[data-radius-wrap]').hidden=false;this.q('[data-location]').textContent=label+' Distances are approximate, straight-line miles.';this.render();this.status.scrollIntoView({block:'center',behavior:'smooth'})}
  locate(){
    const msg=this.q('[data-location]'),button=this.q('[data-locate]');
    if(!navigator.geolocation){msg.textContent='This browser cannot provide your location. Enter a U.S. ZIP above and select Find nearby.';return}
    const request=this.locationRequest=(this.locationRequest||0)+1;let finished=false;
    const finish=()=>{if(finished||request!==this.locationRequest)return false;finished=true;clearTimeout(timer);button.disabled=false;button.textContent='Use my location';return true};
    button.disabled=true;button.textContent='Locating…';msg.textContent='Allow location access in your browser’s prompt. You can also use the ZIP option above.';
    const timer=setTimeout(()=>{if(finish())msg.textContent='Location is taking too long. Check your browser’s location permission, or enter a U.S. ZIP above and select Find nearby.'},20000);
    try{navigator.geolocation.getCurrentPosition(p=>{if(!finish())return;this.setPosition(p.coords.latitude,p.coords.longitude,'Showing dealers near your device location.')},error=>{if(!finish())return;msg.textContent=error.code===1?'Location access is blocked. Allow location for kdequestrian.com in your browser’s site settings, then try again. In a theme preview, open this page in its own tab. Or enter a U.S. ZIP above and select Find nearby.':error.code===3?'Your device did not return a location in time. Try again, or enter a U.S. ZIP above and select Find nearby.':'Your device could not determine its location. Check that device location services are on, or enter a U.S. ZIP above and select Find nearby.'},{timeout:15000,maximumAge:300000,enableHighAccuracy:true})}catch(e){if(finish())msg.textContent='Location is unavailable here. Open this page in its own tab or enter a U.S. ZIP above and select Find nearby.'}
  }
  async locateZip(){
    const input=this.q('[data-nearby-zip]'),zip=input.value.trim(),msg=this.q('[data-location]'),button=this.q('[data-zip-button]');if(!/^\d{5}$/.test(zip)){msg.textContent='Enter a valid five-digit U.S. ZIP code.';input.focus();return}
    const request=this.locationRequest=(this.locationRequest||0)+1;this.q('[data-locate]').disabled=false;this.q('[data-locate]').textContent='Use my location';button.disabled=true;msg.textContent='Finding dealers near '+zip+'…';const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),10000);
    try{const response=await fetch('https://api.zippopotam.us/us/'+encodeURIComponent(zip),{signal:controller.signal});if(!response.ok)throw Error(response.status===404?'zip':'network');const data=await response.json(),place=data.places&&data.places[0];const lat=Number(place&&place.latitude),lng=Number(place&&place.longitude);if(!place||!Number.isFinite(lat)||!Number.isFinite(lng))throw Error('network');if(request===this.locationRequest)this.setPosition(lat,lng,'Showing dealers near '+zip+' ('+place['place name']+', '+place['state abbreviation']+').')}
    catch(error){if(request===this.locationRequest)msg.textContent=error.message==='zip'?'That ZIP code could not be found. Check the ZIP and try again.':'ZIP lookup is temporarily unavailable. Use the directory search or state filter to find dealers.'}finally{clearTimeout(timer);button.disabled=false}
  }
  distance(r){if(!this.position||!Number.isFinite(r.lat)||!Number.isFinite(r.lng)||(r.lat===0&&r.lng===0))return Infinity;const rad=n=>n*Math.PI/180;const a=rad(this.position[0]),b=rad(r.lat),d=rad(r.lat-this.position[0]),e=rad(r.lng-this.position[1]);const h=Math.sin(d/2)**2+Math.cos(a)*Math.cos(b)*Math.sin(e/2)**2;return 3958.8*2*Math.atan2(Math.sqrt(h),Math.sqrt(Math.max(0,1-h)))}
  node(tag,text,cls){const el=document.createElement(tag);if(text)el.textContent=text;if(cls)el.className=cls;return el}
  link(text,url){const a=this.node('a',text);a.href=url;a.target='_blank';a.rel='noopener';return a}
  render(){
    const tokens=this.norm(this.query.value).split(' ').filter(Boolean),radius=this.q('[data-radius]').value;
    const rows=this.rows.filter(r=>(!this.country.value||r.country===this.country.value)&&(!this.region.value||r.region===this.region.value)&&tokens.every(t=>r.index.includes(t)||r.index.replace(/ /g,'').includes(t))&&(!this.position||(Number.isFinite(this.distance(r))&&(radius==='all'||this.distance(r)<=Number(radius)))));
    rows.sort((a,b)=>this.position?this.distance(a)-this.distance(b):Number(this.partners.some(p=>p.id===b.id))-Number(this.partners.some(p=>p.id===a.id))||a.name.localeCompare(b.name));
    const pages=Math.max(1,Math.ceil(rows.length/24));this.page=Math.max(1,Math.min(this.page,pages));const start=(this.page-1)*24;
    this.status.textContent=rows.length?`${rows.length} dealer ${rows.length===1?'listing':'listings'} · Showing ${start+1}–${Math.min(start+24,rows.length)}`:'No dealers match your search.';
    const grid=this.q('[data-results]');grid.replaceChildren();
    if(!rows.length){const box=this.node('div',null,'kdd-empty');box.append(this.node('h3','Let’s widen the search.'),this.node('p',this.position?'Try a larger distance or clear your filters. You can also shop with our featured retailers above.':'Try a nearby city, a broader name, or clear your filters. You can also shop with our featured retailers above.'));grid.append(box)}
    rows.slice(start,start+24).forEach(r=>{const partner=this.partners.find(p=>p.id===r.id);const card=this.node('article',null,'kdd-card'+(partner?' kdd-is-featured':''));
      if(partner){card.append(this.node('span','Featured retailer','kdd-badge'));const img=this.node('img',null,'kdd-card-logo');img.src=partner.logo;img.alt=partner.name;img.width=140;img.height=64;img.loading='lazy';card.append(img)}
      card.append(this.node('h3',partner?partner.name:r.name),this.node('p',r.address));
      if(r.country!=='Other / not specified')card.append(this.node('p',r.country));
      if(this.position)card.append(this.node('p',`${Math.round(this.distance(r))} miles away`));
      if(r.mail)card.append(this.node('p','Mailing address — contact this dealer for visiting details.','kdd-note'));
      const links=this.node('div',null,'kdd-card-links');
      if(r.phone){const a=this.node('a',r.phone);a.href='tel:'+r.phone.replace(/[^+0-9]/g,'');links.append(a)}
      if(partner)links.append(this.link(partner.cta||'Shop K&D ↗',partner.url));else if(/^https?:\/\//i.test(r.web))links.append(this.link('Visit website ↗',r.web));
      if(!r.mail&&r.name!=='LOGAN KINYON'&&/\d/.test(r.address)&&r.address!==r.name)links.append(this.link('Get directions ↗','https://www.google.com/maps/dir/?api=1&destination='+encodeURIComponent(r.address+' '+(r.country==='Other / not specified'?'':r.country))));
      card.append(links);grid.append(card);
    });
    this.q('[data-page]').textContent=rows.length?`Page ${this.page} of ${pages}`:'';this.q('[data-prev]').disabled=this.page<=1;this.q('[data-next]').disabled=this.page>=pages;
  }
});

  } catch(e) { console.error(e); }
})();
})();
